// @flow

export function parseRoomIdParam(roomId) {
  if (/^[0-9]+$/.test(roomId)) {
    return { id: parseInt(roomId, 10) || null }
  }
  return { uid: roomId || null }
}



// WEBPACK FOOTER //
// ./src/helpers/room.js